import React, { useState, useEffect } from 'react';
import axiosInstance from '../components/api/AxiosInstance'; // Ensure axiosInstance is defined or imported correctly
import Loading from './Loading';


export default function Post() {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [selectedRayon, setSelectedRayon] = useState('');
  const [department, setDepartment] = useState(null);
  const [editId, setEditId] = useState(null); // Track the ID of the department being edited
// Loading
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);


  const regions = [
    'Nókis qalasi', 'Beruniy rayonı', 'Bozataw rayonı', 'Ellikqala rayonı', 'Kegeyli rayonı',
    'Moynaq rayonı', 'Nókis rayonı', 'Qanlıkól rayonı', 'Qaraózek rayonı', 'Qońırat rayonı',
    'Shımbay rayonı', 'Shomanay rayonı', 'Taqıyatas rayonı', 'Taxtakópir rayonı',
    'Tórtkúl rayonı', 'Xojeli rayonı', 'Ámiwdárya rayonı'
  ];

  useEffect(() => {
    axiosInstance.get("/company", { headers: {"ngrok-skip-browser-warning": "true"}})
    .then(response => {
      setDepartment(response.data.companies);
      setIsLoading(false);
      

    })
    .catch(error => {
      console.error('Error fetching admin data from API:', error);
      setIsLoading(false);
  

    });
  }, [department]);

  
  const addDepartment = async (event) => {
    const isConfirmed = window.confirm('Are you sure ?');
  
    if (!isConfirmed) {
      return; // Exit the function if the user cancels the confirmation dialog
    }
    
    event.preventDefault();

    const data = {
      phone_number: phone,
      address,
      name,
      email,
      password,
      region: selectedRayon,
    };

    try {
      if (editId) {
        await axiosInstance.put(`/company/${editId}`, data);
        console.log('Department updated');
      } else {
        await axiosInstance.post('/company', data);
        console.log('Department added');
      }

      resetForm();
    } catch (error) {
      console.error('Error saving department:', error);
    }finally {
     
    }
  };

  const deleteDepartment = async (id) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this department?');
  
    if (!isConfirmed) {
      return; // Exit the function if the user cancels the confirmation dialog
    }
  

  
    try {
      await axiosInstance.delete(`/company/${id}`);
      console.log('Department deleted');
    } catch (error) {
      console.error('Error deleting department:', error);
    } finally {
  
    }
  };
  

  const editDepartment = (id) => {
    const isConfirmed = window.confirm('Are you sure ?');
  
    if (!isConfirmed) {
      return; // Exit the function if the user cancels the confirmation dialog
    }
    const dept = department.find(d => d.id === id);
    setName(dept.name);
    setPhone(dept.phone_number);
    setAddress(dept.address);
    setEmail(dept.email);
    setPassword(dept.password);
    setSelectedRayon(dept.region);
    setEditId(id); // Set the edit ID
  };

  const resetForm = () => {
    setName('');
    setAddress('');
    setPhone('');
    setEmail('');
    setPassword('');
    setSelectedRayon('');
    setEditId(null); // Reset the edit ID
  };

  if (loading || isLoading) {
    return <Loading />;
  }


  return (
    <div>
      <div className='create-box'>
        <form onSubmit={addDepartment}>
          <div>
            <label>Bo'lim nomi <strong>*</strong></label>
            <input 
              type='text' 
              placeholder="Bo'lim nomi" 
              value={name} 
              onChange={(e) => setName(e.target.value)} 
              required

            />
          </div>
          <div>
            <label>Telefon raqami <strong>*</strong></label>
            <input 
              type='text' 
              placeholder='Telefon raqami' 
              value={phone} 
              onChange={(e) => setPhone(e.target.value)} 
              required

            />
          </div>
          <div>
            <label>Manzil <strong>*</strong></label>
            <input 
              type='text' 
              placeholder='Manzil' 
              value={address} 
              onChange={(e) => setAddress(e.target.value)} 
              required

            />
          </div>
          <div>
            <label>Username <strong>*</strong></label>
            <input 
              type='text' 
              placeholder='Username' 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required

            />
          </div>
          <div>
            <label>Password <strong>*</strong></label>
            <input 
              type='text' 
              placeholder='Password' 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required
            />
          </div>
          <div>
            <label>Tuman <strong>*</strong></label>
            <br />
            <select required
              value={selectedRayon} 
              onChange={(e) => setSelectedRayon(e.target.value)}>
              
              <option value="" disabled>Select a category</option>
              {regions.map((region, index) => (
                <option key={index} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>
          <div className='btn-edit-box'>
            <button type="submit">{editId ? "Yangilash" : "Yaratish"}</button>
            {editId && (
              <button type="button" onClick={resetForm}>
                Cancel
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="update">
        <div className="update-table">
          <div className='update-table-1'>
          <div><h5>№</h5></div>
          <div className="dept_car"><h5>Bo'lim nomi</h5></div>
          <div className="model_car"><h5>Telefon raqami</h5></div>
          <div className="number_car"><h5>Manzil</h5></div>
          <div className="address_car"><h5>Tuman</h5></div>
          <div className="year_car"><h5>Username</h5></div>
          <div className="status_car"><h5>Password</h5></div>
          </div>
          <div className='btn_car-t'>

            </div>
        </div>

        {(department ?? []).map((e ,index) => (  <div  className="update-table map" key={e.id} >
            <div className='update-table-1' id='hup'> 
            <div><h5>{index+1}</h5></div>
            <div className="dept_car"><h5>{e.name}</h5></div>
            <div className="model_car"><h5>{e.phone_number}</h5></div>
            <div className="number_car"><h5>{e.address}</h5></div>
            <div className="address_car"><h5>{e.region}</h5></div>
            <div className="year_car"><h5>{e.email}</h5></div>
            <div className="status_car"><h5>{e.password}</h5></div>
            </div>

            <div className='btn_car-t'>
              <button className='edit-btn' onClick={() => editDepartment(e.id)}>Tahrirlash</button>
              <button className='delete-btn' onClick={() => deleteDepartment(e.id)}>O'chirish</button>
            </div>
       
          </div>
        ))}
      </div>
    </div>
  );
}
